import React, { useEffect, useState } from "react";
import HeroBanner from "../../components/DynamicHero";
import Intro from "../../components/services/gallery/Intro";
import { setMetaTag, setPropertyMetaTag } from "../../helpers/seoUtils";
import GalleryTab from "../../components/services/gallery/GalleryTab";
import { useTranslation } from "react-i18next";
import { getGalleryMedia } from "../../helpers/xhr";
import { GalleryMedia } from "../../types/galleryTypes";
import { GalleryContext } from "../../context/GalleryContext";
const GalleryPage = () => {
  const { t } = useTranslation("common");
  const [galleryMedia, setGalleryMedia] = useState<GalleryMedia | undefined>(
    undefined
  );
  useEffect(() => {
    document.title = "Gallery – Economus";

    setMetaTag(
      "description",
      "Explore our gallery showcasing playground equipment, repairs, installations, and outdoor sports projects across Lithuania."
    );
    setMetaTag(
      "keywords",
      "playgrounds, gallery, playground installations, Economus, vaikų aikštelės, sporto aikštelės, įranga, darbai Lietuvoje"
    );
    setMetaTag("robots", "index, follow");
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Gallery – Economus");
    setMetaTag(
      "twitter:description",
      "A visual showcase of our playground and outdoor equipment projects."
    );
    setMetaTag(
      "twitter:image",
      "https://economus.netlify.app/static/media/work-completed23.3d513d3c6d73a8d33abb.webp"
    );
    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");

    setPropertyMetaTag("og:title", "Gallery – Economus");
    setPropertyMetaTag(
      "og:description",
      "Explore visuals of our completed and ongoing playground and sports infrastructure work."
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.netlify.app/static/media/work-completed23.3d513d3c6d73a8d33abb.webp"
    );
    setPropertyMetaTag("og:url", "https://economus.netlify.app/gallery");
    setPropertyMetaTag("og:type", "website");

    const fetchGalleryMedia = async () => await getGalleryMedia();
    fetchGalleryMedia().then((data) => setGalleryMedia(data));
  }, []);

  return (
    <>
      <HeroBanner text={t("navGallery")} />
      <Intro />
      {galleryMedia !== undefined && (
        <GalleryContext.Provider value={galleryMedia}>
          <GalleryTab />
        </GalleryContext.Provider>
      )}
    </>
  );
};

export default GalleryPage;
